
import { memo, useState } from "react";

import { IonCol, IonGrid, IonLabel, IonRow, IonText, IonToggle } from "@ionic/react";

import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
        },
        button: {
            marginTop: theme.spacing(1),
            marginRight: theme.spacing(1),
        },
        actionsContainer: {
            marginBottom: theme.spacing(2),
        },
        resetContainer: {
            padding: theme.spacing(3),
        },
    }),
);


const Usuario = ({
    handleNext,
    handleBack,
    formik: {
        errors,
        touched,
        setTouched,
        values,
        handleChange
    } }: any) => {

    //console.log({ errors, values });

    const classes = useStyles();

    const [showPassword, setShowPassword] = useState(false);

    return (
        <>
            <IonGrid className="ion-padding-none">
                <IonRow>

                    <IonCol className="ion-text-center" size="12">
                        <img
                            src={process.env.PUBLIC_URL + '/assets/img/steps/digital-nomad.png'}
                            height={120}
                            alt=""
                        />
                    </IonCol>

                    <IonCol sizeXl="6" sizeMd="6" sizeSm="12" sizeXs="12">
                        <TextField
                            label="Nombre(s)"
                            type="text"
                            inputMode="text"
                            id={"Escuela.Usuario.nombre"}
                            name={"Escuela.Usuario.nombre"}
                            value={values.Escuela.Usuario.nombre}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.Usuario,
                                    Usuario: {
                                        ...touched?.Escuela?.Usuario,
                                        nombre: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.Usuario?.nombre && errors?.Escuela?.Usuario?.nombre}
                            required
                            variant="outlined"
                            size="medium"
                            margin="normal"
                            fullWidth
                        />
                    </IonCol>

                    <IonCol sizeXl="6" sizeMd="6" sizeSm="12" sizeXs="12">
                        <TextField
                            label="Apellidos"
                            type="text"
                            inputMode="text"
                            id={"Escuela.Usuario.apellido"}
                            name={"Escuela.Usuario.apellido"}
                            value={values.Escuela.Usuario.apellido}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.Usuario,
                                    Usuario: {
                                        ...touched?.Escuela?.Usuario,
                                        apellido: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.Usuario?.apellido && errors?.Escuela?.Usuario?.apellido}
                            required
                            variant="outlined"
                            size="medium"
                            margin="normal"
                            fullWidth
                        />
                    </IonCol>

                    <IonCol sizeXl="12" sizeMd="12" sizeSm="12" sizeXs="12">
                        <TextField
                            label="Correo electrónico"
                            type="email"
                            inputMode="email"
                            id={"Escuela.Usuario.email"}
                            name={"Escuela.Usuario.email"}
                            value={values.Escuela.Usuario.email}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.Usuario,
                                    Usuario: {
                                        ...touched?.Escuela?.Usuario,
                                        email: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.Usuario?.email && errors?.Escuela?.Usuario?.email}
                            required
                            variant="outlined"
                            size="medium"
                            margin="normal"
                            fullWidth
                        />
                    </IonCol>


                    <IonCol sizeXl="12" sizeMd="12" sizeSm="12" sizeXs="12">
                        <TextField
                            label="Contraseña"
                            type={!showPassword ? 'password' : 'text'}
                            inputMode="text"
                            id={"Escuela.Usuario.password"}
                            name={"Escuela.Usuario.password"}
                            value={values.Escuela.Usuario.password}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.Usuario,
                                    Usuario: {
                                        ...touched?.Escuela?.Usuario,
                                        password: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.Usuario?.password && errors?.Escuela?.Usuario?.password}
                            required
                            variant="outlined"
                            margin="normal"
                            size="medium"
                            fullWidth
                            InputProps={{
                                endAdornment: (
                                    <>
                                        <IonToggle
                                            onIonChange={() => setShowPassword(!showPassword)}
                                        />
                                        <IonLabel>&nbsp; {!showPassword ? `Mostrar` : `Ocultar`} contraseña</IonLabel>
                                    </>
                                )
                            }}
                        />

                        {(touched?.Escuela?.password && errors?.Escuela?.Usuario?.password) && <IonText color="danger" style={{ fontSize: '12px' }}>
                            {errors?.Escuela?.Usuario?.password}
                        </IonText>}

                    </IonCol>

                    {/* <IonCol sizeXl="12" sizeMd="12" sizeSm="12" sizeXs="12">
                        <TextField
                            label="Teléfono de contacto"
                            type="tel"
                            inputMode="tel"
                            id={"Escuela.Usuario.mobil"}
                            name={"Escuela.Usuario.mobil"}
                            value={values.Escuela.Usuario.mobil}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.Usuario,
                                    Usuario: {
                                        ...touched?.Escuela?.Usuario,
                                        mobil: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.Usuario?.mobil && errors?.Escuela?.Usuario?.mobil}
                            required
                            variant="outlined"
                            size="medium"
                            margin="normal"
                            fullWidth
                        />

                        {touched?.Escuela?.mobil && errors?.Escuela?.Usuario?.mobil && (<IonText color="danger" style={{ fontSize: '12px' }} className="ion-text-wrap"> El teléfono debe contener 10 caracteres y usted escribió <b>{values.Escuela.Usuario.mobil?.toString()?.length}</b> caracteres.</IonText>)}
                    </IonCol> */ }


                    <div className={classes.actionsContainer}>
                        <div className="ion-padding">
                            <Button
                                onClick={handleBack}
                                className={classes.button}
                            >
                                Anterior
                            </Button>

                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleNext}
                                className={classes.button}
                                // || !touched.Escuela.hasOwnProperty('Usuario')
                                disabled={errors?.Escuela?.hasOwnProperty('Usuario')}
                            >
                                Siguiente
                            </Button>
                        </div>
                    </div>

                </IonRow>

            </IonGrid>

        </>

    );
};

export default memo(Usuario);